import { mapToBaseError } from '@/data/common/mappers/ErrorMapper';
import { MutationOptions } from '@/data/common/types';
import { LoginRepository } from '@/domain/auth/repositories/LoginRepository';
import { BaseError } from '@/domain/vo/BaseError';
import { useLoginMutation } from '../sources/LoginMutation';
import { setCookie } from '@/utils/cookie.util';
import { ACCESS_TOKEN_KEY, TIME_ACCESS_TOKEN_KEY } from '@/constants';
import { ILoginVariables } from '@/domain/auth/entities';
// import { getUserAuthByToken } from '@/utils/permission';
// import userService from '@/services/UserService';
// import { checkEmptyArray } from '@/utils/variable';

export const useLoginUsecase = ({
  onError,
  onSuccess,
  ...options
}: MutationOptions): LoginRepository => {
  let error: BaseError | null = null;

  const {
    mutate,
    data,
    error: _error,
    ...rest
  } = useLoginMutation({
    onSuccess: async (dataSuccess, ...args) => {
      if (dataSuccess) {
        const {
          data: { token },
        } = dataSuccess;
        if (token) setCookie(ACCESS_TOKEN_KEY, token, TIME_ACCESS_TOKEN_KEY);
        // const auth = getUserAuthByToken(token);
        // if (auth) {
        //   const { data } = await userService.getProfile({
        //     ids: [auth.userId],
        //   });
        //   if (checkEmptyArray(data) && Array.isArray(data))
        //     return onSuccess?.(
        //       {
        //         token,
        //         auth,
        //         item: data[0],
        //       },
        //       ...args,
        //     );
        // }

        return onSuccess?.(dataSuccess?.data, ...args);
      }
    },
    onError: (dataError, ...args) => {
      if (dataError) onError?.(dataError, ...args);
    },
    ...options,
  });

  const login = (input: ILoginVariables) => {
    mutate(input);
  };
  if (_error) error = mapToBaseError(_error);

  return {
    login,
    error,
    isLoading: true,
    data: data?.data ?? undefined,
    ...rest,
  };
};
